import Router from 'next/router';
import React, { useState, createContext, useContext, useEffect } from 'react';
import { useThrottle } from 'use-throttle';
import useThrowableHttpGet from 'hooks/useThrowableHttpGet';
import { node } from 'prop-types';

const SearchContext = createContext(null);
export const useSearchContext = () => useContext(SearchContext);

function SearchProvider({ children }) {
  const [keyword, setKeyword] = useState('');
  const throttledKeyword = useThrottle(keyword, 500);

  useEffect(() => {
    Router.events.on('routeChangeComplete', (nextURL) => {
      // Reset search keyword when users go to homepage
      if (nextURL === '/') {
        setKeyword('');
      }
    });
  }, []);

  const params = {
    page: 1,
    itemsPerPage: 5,
    keyword: '',
  };
  if (throttledKeyword) params.keyword = throttledKeyword;

  const { response } = useThrowableHttpGet('/api/hc/search/', params);

  return (
    <SearchContext.Provider value={{ articles: response, keyword, setKeyword }}>
      {children}
    </SearchContext.Provider>
  );
}

SearchProvider.propTypes = {
  children: node,
};

export default SearchProvider;
